import { Observable,Subscriber } from "rxjs";
import { math } from "../math";
import * as css from './css';
import { resizeObserver } from './resize-observer';
export { AnimationFrameRequest } from './animation-frame-request';
export * as file from './file';
export { css };

declare global{
	interface NodeListOf<TNode extends Node> extends NodeList {
		keys():Iterator<number>;
		values():Iterator<TNode>;
		entries():Iterator<[number,TNode]>;
		[Symbol.iterator]():Iterator<TNode>;
	}
}

export class SizeObservable extends Observable<math.Vec2>{
	private target:Element;
	private callback:any;
	private subscribers:Subscriber<math.Vec2>[]=[];
	private size:math.Vec2;
	private resizeOnly:boolean;

	public readonly completeThis=true;

	public constructor(options:{
		resizeOnly?:boolean
	}={}){
		super(subscriber=>{
			this.subscribers.push(subscriber);
			if(!this.resizeOnly && this.size)
				subscriber.next(this.size);
		});
		if(options.resizeOnly)
			this.resizeOnly=true;
	}

	private nextSize(size:math.Vec2){
		if(!this.size?.equals(size)){
			this.size=size;
			for(const sub of this.subscribers)
				sub.next(size);
		}
	}

	public observe(target:Element){
		this.target=target;
		if(!this.resizeOnly){
			this.nextSize(new math.Vec2(
				target.clientWidth,
				target.clientHeight
			));
		}
		this.callback=resizeObserver().add(target,e=>{
			this.nextSize(new math.Vec2(
				e.contentRect.width,
				e.contentRect.height,
			));
		});
	}

	public complete(){
		resizeObserver().delete(this.target,this.callback);
		delete this.target;
		delete this.callback;
		for(const sub of this.subscribers)
			sub.complete();
		this.subscribers=[];
		delete this.size;
	}
}
